import { Builder, withChildren } from '@builder.io/react';
import { telemetryIncrementAction } from 'core-events/actions';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import { Button as ButtonComponent, ButtonProps } from '@videoblocks/design-system';

import { SparkleIcon } from './SparkleIcon';

interface ButtonBuilderProps extends Omit<ButtonProps, 'variant'> {
    variant?: 'primary' | 'secondary' | 'outlined-dark' | 'outlined-light' | 'text' | 'alternate';
    link?: string;
    forAIPurpose?: boolean;
    telemetryTag?: string;
}

// Tailwind classes for button with AI purpose  ( AI Voiceover )
const AI_CLASSES = [
    'text-gray-900',
    'rounded-[.75rem]',
    // Gradient border effect using background
    'p-0.5',
    'bg-gradient-to-r',
    'from-purple-600',
    'via-pink-200',
    'to-pink-400',
    // direct child styling to avoid specific variant
    '[&>a]:!bg-bubblegum-100',
    '[&>a]:hover:!bg-transparent',
    '[&>a]:!rounded-[.75rem]',
    '[&>a]:!px-2',
    '[&>a]:!no-underline',
].join(' ');

function Button({
    children,
    variant,
    className,
    size,
    disabled,
    link,
    target,
    forAIPurpose = false,
    telemetryTag,
}: ButtonBuilderProps) {
    const handleClick = () => {
        if (telemetryTag && !Builder.isEditing) {
            void telemetryIncrementAction(telemetryTag);
        }
    };

    return (
        <ButtonComponent
            variant={variant}
            className={forAIPurpose ? twMerge(className, AI_CLASSES) : className}
            size={size}
            disabled={disabled}
            href={link}
            target={target}
            onClick={handleClick}
            iconPrefix={forAIPurpose ? <SparkleIcon className="w-4 h-4" /> : null}
        >
            {children}
        </ButtonComponent>
    );
}

export default withChildren(Button);
